var React = require('react');

function Axe (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M592 160v32c0 97.05-79 176-176 176h-32v48h32c123.71 0 224-100.29 224-224v-32zM4.69 439.43a16 16 0 0 0 0 22.63L50 507.31a16 16 0 0 0 22.63 0l235.82-235.87-67.88-67.88zM507.31 72.57a16 16 0 0 0 0-22.63L462.06 4.69a16 16 0 0 0-22.63 0l-34.5 34.5 67.88 67.88z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384 301.74L233.37 151.11a32 32 0 0 1 0-45.25l96.49-96.49a32 32 0 0 1 45.26 0L525.74 160H560v32c0 79.4-64.6 144-144 144h-32z","className":"fa-primary","key":2})]);
}

Axe.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Axe;

Axe.default = Axe;
